var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotRegisteredEventIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.258,
    height: 18.418,
    viewBox: "0 0 15.258 18.418",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Path_3457",
    "data-name": "Path 3457",
    transform: "translate(-619.936 -2877.071)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M619.936,2877.071h15.258v18.418l-7.279-7.339-7.979,7.339Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 621.935546875 2879.070556640625 L 621.935546875 2890.931640625 L 627.9783325195312 2885.373779296875 L 633.193359375 2890.6318359375 L 633.193359375 2879.070556640625 L 621.935546875 2879.070556640625 M 619.935546875 2877.070556640625 L 635.193359375 2877.070556640625 L 635.193359375 2895.48828125 L 627.9146118164062 2888.149658203125 L 619.935546875 2895.48828125 L 619.935546875 2877.070556640625 Z",
    stroke: "none",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotRegisteredEventIcon);
export default __webpack_public_path__ + "static/media/not_registered_event_icon.cb5ff8408c5f3358c7deba79654c891e.svg";
export { ForwardRef as ReactComponent };